import React from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownMultiSearch,
  CustomDropdownSearch,
  ResponsiveView,
} from "../../../../../../components";
import "./index.scss";
import {
  ICompanyItem,
  IOnSearchUser,
} from "../../../../../../types/common.interface";
import values from "../../../../../../values";
import { useQuery } from "react-query";
import api from "../../../../../../api";
import utils from "../../../../../../utils";
import Cookies from "js-cookie";
import constants from "../../../../../../values/constants";
import { useTranslation } from "react-i18next";
import Context from "../../../../../../context";

const Filter = () => {
  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { setFactorRequest, factorRequest } = React.useContext(Context.PaymentOnline2CompanyContext);
  const userType = utils.stringHexConversion.reverse(Cookies.get(constants.USER.TYPE));
  const { t } = useTranslation();

  const payerTypeArray = [
    {_id: 0, name: 'همه'   , value: undefined  },
    {_id: 1, name: 'راننده', value: 'DRIVER'   },
    {_id: 2, name: 'اولیاء', value: 'PASSENGER'},
  ]

  const [searchedValueCompany, setSearchedValueCompany] = React.useState<IOnSearchUser>();
  const [selectedCompany, setSelectedCompany] = React.useState<any>();
  const [selectdType, setSelectedType] = React.useState<any>(payerTypeArray[0]);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const getAllCompany = useQuery(
    [values.useQueryKeys.getAllCompany, searchedValueCompany?.searchedValue],
    () => api.post.administrator.getAllCompany({
        search: {
          base: searchedValueCompany?.base?.value,
          value: searchedValueCompany?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" }
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  const companyInformationWithCompanyName = getAllCompany?.data?.result?.map(
    (item: any) => ({...item, companyName: item?.companyInformation?.companyName,})
  );

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <div className="filter-container">
      <CustomDropdownFilter title={t("filter")} hoverTitle={t("filter")} min_width="30vw">
        <ResponsiveView.Row>
          {userType !== "COMPANY" && (
            <ResponsiveView.Column medium={12}>
              <label className="form-label">{t("company")}</label>
              <CustomDropdownMultiSearch
                isSearch
                baseSearch={values.dropdownBaseSearch.COMPANY_BASE_SEARCH.map((item) => ({
                  ...item,
                  title: t(item.title)
                }))}
                items={companyInformationWithCompanyName}
                itemName="companyName"
                onSelectItem={(event: ICompanyItem) => {
                  setSelectedCompany(event);
                  setFactorRequest!({
                    page: 1,
                    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                    company: event?._id,
                    payerType: factorRequest?.payerType,
                  });
                }}
                defaultItem={factorRequest?.company ? selectedCompany : undefined}
                searchedValue={searchedValueCompany}
                setSearchedValue={setSearchedValueCompany}
                placeHolder={t("selectCompany")}
                isLoading={getAllCompany.isLoading}
                selectedBaseSearch={
                  searchedValueCompany?.base?.value === "nationalCode"
                    ? "companyInformation.nationalCode"
                    : searchedValueCompany?.base?.value
                }
              />
            </ResponsiveView.Column>
          )}
          <ResponsiveView.Column medium={12}>
            <label className="form-label">پرداخت کننده</label>
            <CustomDropdownSearch
              items={payerTypeArray}
              itemName={'name'}
              placeHolder={'انتخاب پرداخت کننده'}
              onSelectItem={(item: any) => {
                setSelectedType(item);
                setFactorRequest!({
                  page: 1,
                  limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                  company: factorRequest?.company,
                  payerType: item?.value,
                })
              }}
              defaultItem={factorRequest?.payerType ? selectdType : payerTypeArray[0]}
              isSearch={false}
            />
          </ResponsiveView.Column>
        </ResponsiveView.Row>
        <div className="filter-footer">
          <CustomButton2
            title={t("reset")}
            onClick={() => {setFactorRequest!({limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT, page: 1,})}}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default Filter;
